module.exports = __webpack_public_path__ + "img/medium-safe.29bbeada.svg";